import React from 'react'
import { Box } from '@mui/material'
import { INTERAX_COLORS } from '../../../constants/colors'
import type { SprintPurposeOption } from './SprintPurpose.types'

interface SprintPurposeContentProps {
  purpose: SprintPurposeOption
  translate: (key: string) => string
}

interface SprintPurposeContentSectionProps {
  labelKey: string
  value: string
  translate: (key: string) => string
}

const SprintPurposeContentSection: React.FC<SprintPurposeContentSectionProps> = ({ labelKey, value, translate }) => (
  <Box>
    <Box className="text-field-label" sx={{ color: INTERAX_COLORS.sun, mb: '4px' }}>
      {translate(labelKey)}:
    </Box>
    <Box className="text-body-3" sx={{ color: INTERAX_COLORS.white }}>
      {translate(value)}
    </Box>
  </Box>
)

export const SprintPurposeContent: React.FC<SprintPurposeContentProps> = ({ purpose, translate }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', mb: '24px' }}>
    <Box>
      <Box className="text-headline-3" sx={{ color: INTERAX_COLORS.white, mb: '8px' }}>
        {translate(purpose.title)}
      </Box>
      <Box className="text-body-3" sx={{ color: INTERAX_COLORS.thunderGrey }}>
        {translate(purpose.tooltip)}
      </Box>
    </Box>

    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <SprintPurposeContentSection
        labelKey="facilitator.trainingSprint.purpose.why"
        value={purpose.why}
        translate={translate}
      />
      <SprintPurposeContentSection
        labelKey="facilitator.trainingSprint.purpose.forWhom"
        value={purpose.forWhom}
        translate={translate}
      />
      <SprintPurposeContentSection
        labelKey="facilitator.trainingSprint.purpose.learningGoals"
        value={purpose.learningGoals}
        translate={translate}
      />
    </Box>
  </Box>
)

export default SprintPurposeContent
